import React from 'react';
import { useTranslation } from 'react-i18next';

import GetCasinoGameResponse from 'casino/Api/CRM/Responses/CasinoGameResponse';

type Props = {
    game: GetCasinoGameResponse;
};

function CasinoGamesCarouselItem({ game }: Props) {
    const { t } = useTranslation();

    return (
        <div className="casino-game-wrapper">
            <div className="casino-game">
                <div className="casino-game-image">
                    <img src={game.image} alt={`${game.creator_name} ${game.name}`} />
                </div>
                <div className="casino-game-link-wrapper">
                    <a className="play" href={game.play_url}>{t('casino.slider.playNow')}</a>
                    {game.has_demo ? (
                        <a className="play-demo" href={game.play_demo_url}>{t('casino.slider.playDemo')}</a>
                    ) : null }
                </div>
            </div>
        </div>
    );
}

export default CasinoGamesCarouselItem;
